import React, { Component } from 'react'
import styled from 'styled-components'
import { Flex } from 'reflexbox'
import colors from '../config/colors';
import DownloadButton from '../components/DownloadButton';

const GOOGLEPLAYLINK = 'https://play.google.com/store/apps/details?id=com.plicca.android';
const APPSTORELINK = 'https://apps.apple.com/us/app/trivia-together/id1504946180?ls=1';

const BackgroundImage = styled(Flex)`
    
    
    background-color: ${colors.Blue};
    background-size: cover;
    height: 185vw;

    justify-content: center;
    align-items: center;
    width: 100%;

    background-position: center;
    background-image: url(/assets/imgs/MobileHomepageBackground.svg);
    background-repeat: no-repeat;


    @media only screen and (min-width: 641px) {
        
        height: 116vw;
        background-size: cover;
        background-image: url(/assets/imgs/TabletHomepageBackground.svg);
    }

    @media only screen and (min-width: 832px) {
        
        height: 840px;
        background-size: auto;
        background-image: url(/assets/imgs/DesktopHomepageBackground.svg);
    }  
`;

const ButtonsContainer = styled(Flex)`

    justify-content: space-around;
    align-items: center;
    max-width: 600px;
    height: 40vw;

    @media only screen and (min-width: 641px) {
        padding-top: 20em;
    }
`;

const StyledDownloadButton = styled(DownloadButton)`
    padding: 1em;
`;

interface HomepageIProps {

}

interface HomepageIState {

}

export default class Homepage extends Component<HomepageIProps, HomepageIState>{

    render() {
        return <BackgroundImage>
            <ButtonsContainer width={['100%', '90%', '80%']} flexDirection={['column', 'row']}>
                <StyledDownloadButton targetURL={GOOGLEPLAYLINK} imageURL='/assets/imgs/Playstore.png' availablePhrase='DOWNLOAD IT FROM' storeName='GooglePlay' />
                <StyledDownloadButton targetURL={APPSTORELINK} imageURL='/assets/imgs/AppleStore.png' availablePhrase='DOWNLOAD IT FROM' storeName='App Store' />
            </ButtonsContainer>
        </BackgroundImage>
    }

}
